import type { IAPI } from '../../apiResponse';
import { getRequest, type IRequestOptions } from '../../httpClient';
import {
  getChallengePageBundleV1ResponseSchema,
  type IChallengePageBundleV1,
} from './get-challenge-page-bundle-v1-response';

export async function getChallengePageBundleV1Api(
  slug: string,
  limit?: number,
  options?: IRequestOptions,
) {
  const query = limit ? `?limit=${limit}` : '';
  return getRequest<IAPI<IChallengePageBundleV1>>({
    path: `/challenges/v1/slug/${encodeURIComponent(slug)}/page-bundle${query}`,
    schema: getChallengePageBundleV1ResponseSchema,
    options,
  });
}
